export default __webpack_public_path__ + "static/media/cat4-1.27c5063f.jpg";